"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = QuoteOpenFill;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function QuoteOpenFill(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "quote-open-fill"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M29.313,42.562a15.561,15.561,0,0,1,.241-2.093,20.541,20.541,0,0,1,3.679-8.245,37.384,37.384,0,0,1,7.313-7.5l.036-.027a2.531,2.531,0,0,0-2.166-4.444,45.017,45.017,0,0,0-11.549,4.438A32.7,32.7,0,0,0,10.36,47.427a38.147,38.147,0,0,0-.735,7.728,36.814,36.814,0,0,0,.222,3.964c.072.673.164,1.35.29,2.06.058.347.133.717.215,1.094l.145.6.1.348.055.186.119.326c.008.018.019.034.027.052A17.495,17.495,0,1,0,29.313,42.562Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M73.567,42.562a15.728,15.728,0,0,1,.242-2.093,20.527,20.527,0,0,1,3.679-8.245,37.33,37.33,0,0,1,7.313-7.5l.035-.027a2.531,2.531,0,0,0-2.166-4.444,45.011,45.011,0,0,0-11.548,4.438A32.7,32.7,0,0,0,54.615,47.427a38.148,38.148,0,0,0-.736,7.728,37.336,37.336,0,0,0,.222,3.964c.072.673.165,1.35.29,2.06.058.347.133.717.215,1.094l.145.6.1.348.056.186.119.326c.008.018.018.034.026.052A17.5,17.5,0,1,0,73.567,42.562Z"
  }))));
}